import { Component, OnInit, Input, Inject } from '@angular/core';

import { IPicture } from '@finder/shared/components/picture/picture.interface';
import { StripHTMLTagsFromStringProvider, STRIP_HTML_TAGS_FROM_STRING } from '@finder/shared/utils/string/stripHtmlTagsFromString';

@Component({
    selector: 'finder-button-card',
    templateUrl: './button-card.component.html',
    styleUrls: ['./button-card.component.scss']
})
export class ButtonCardComponent implements OnInit {

    @Input() imageData: any;
    @Input() title: string;
    @Input() link: string;
    @Input() copy: string;
    @Input() ariaLabel: string;

    public picture: IPicture;

    constructor(
        @Inject(STRIP_HTML_TAGS_FROM_STRING) private stripHtmlTagsFromString: StripHTMLTagsFromStringProvider
    ) { }

    ngOnInit() {
        this.picture = this.mapImageData();

        if (this.ariaLabel) {
            this.ariaLabel = this.stripHtmlTagsFromString(this.ariaLabel);
        }
    }

    mapImageData(): IPicture | undefined {
        let result: IPicture;

        if (this.imageData) {
            result = {
                mobile: this.imageData.mobile,
                desktop: this.imageData.desktop,
                media: this.imageData.media,
                alt: this.imageData.alt
            };
        }

        return result;
    }

}
